export default __webpack_public_path__ + "static/media/header-logo.91a04c68.svg";